// Helper function to map startingAngle to display labels
export const getStartingAngleDisplayName = (angle: string) => {
  switch (angle) {
    case 'quickstart':
      return 'Solving a challenge'
    case 'quickstartdynamic':
      return 'Brainstorming'
    case 'smartnotes':
      return 'Project planning'
    case 'blank':
      return 'Blank - Full customization (Advanced)'
    case 'interview':
      return 'Interview'
    case 'survey':
      return 'Survey'
    case 'chat':
      return 'Chat'
    case 'research':
      return 'Research'
    default:
      return angle.charAt(0).toUpperCase() + angle.slice(1)
  }
}

// Helper function to get starting angle descriptions
export const getStartingAngleDescription = (angle: string) => {
  switch (angle) {
    case 'interview':
      return 'Start with interview tools and data collection forms'
    case 'survey':
      return 'Begin with survey creation and response analysis'
    case 'quickstart':
      return 'Ready-made project template with basic structure'
    case 'quickstartdynamic':
      return 'Dynamic situational awareness mapping for complex scenarios'
    case 'smartnotes':
      return 'Intelligent note-taking with auto-organization'
    case 'chat':
      return 'AI-powered chat interface for brainstorming'
    case 'research':
      return 'Simple research topic definition and development'
    case 'blank':
      return 'Empty project for full customization (advanced)'
    default:
      return ''
  }
} 